import { useMemo } from "react";

import Modal from "components/common/Modal";
import useModal from "hooks/useModal";
import ChildForm from "components/ProfileEditor/children/ChildForm";

export const CHILD_EDITOR_WIZARD_MODAL_NAME = "CHILD_EDITOR_WIZARD_MODAL";

const ChildEditorWizardModal = () => {
  const { options, close } = useModal(CHILD_EDITOR_WIZARD_MODAL_NAME);
  const { client, childId, isWizard } = options || {};

  const child = useMemo(() => {
    if (!client?.children || !childId) return null;
    return client.children.find((c) => c?.id === childId) || null;
  }, [client, childId]);

  if (!client || !child) return null;

  return (
    <Modal
      name={CHILD_EDITOR_WIZARD_MODAL_NAME}
      title="Edit Child"
      size="lg"
      showCloseButton
      onHide={close}
      style={isWizard ? { width: "80vw", maxWidth: "1200px" } : {}}
      dialogClassName={isWizard ? "wizard-wide-modal" : undefined}
      enforceFocus={isWizard ? false : undefined}
    >
      <ChildForm user={{ client }} child={child} onDeleted={isWizard ? close : undefined} />
    </Modal>
  );
};

export default ChildEditorWizardModal;
